module.exports = __webpack_public_path__ + "images/stickers/taco-proto.2e050937d34005636192.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-proto.png
// module id = 6SJx
// module chunks = 0